import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeyboardArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1683 205 1517 40Q1498 21 1472.0 21.0Q1446 21 1427 40L896 571L365 40Q346 21 320.0 21.0Q294 21 275 40L109 205Q90 224 90.0 250.5Q90 277 109 296L851 1037Q870 1056 896.0 1056.0Q922 1056 941 1037L1683 296Q1702 277 1702.0 250.5Q1702 224 1683 205Z"
	})
});
export default SvgKeyboardArrowUp;
